import * as allergiesType from "../../action/actiontype/AllergiesType/AllergiesType";

const AllergiesReducer = (state = {}, action) => {

    switch (action.type) {

        case allergiesType.ALLERGIES_REQUEST_GETBYALL_ID:
            return {
                ...state,
                allergiesGetAllIdLoading: true,
                allergiesGetAllIdResponse: {},
                allergiesGetAllIdError: null,
            }

        case allergiesType.ALLERGIES_SUCCESS_GETBYALL_ID:
            return {
                ...state,
                allergiesGetAllIdLoading: false,
                allergiesGetAllIdResponse: action.payload,
                allergiesGetAllIdError: null,
            }
        case allergiesType.ALLERGIES_FAILURE_GETBYALL_ID:
            return {
                ...state,
                allergiesGetAllIdLoading: false,
                allergiesGetAllIdResponse: {},
                allergiesGetAllIdError: action.payload,
            }
        case allergiesType.ALLERGIES_REQUEST_ADD:
            return {
                ...state,
                allergiesAddLoading: true,
                allergiesAddResponse: {},
                allergiesAddeError: null,
            }
        case allergiesType.ALLERGIES_SUCCESS_ADD:
            return {
                ...state,
                allergiesAddLoading: false,
                allergiesAddResponse: action.payload,
                allergiesAddeError: null,
            }
        case allergiesType.ALLERGIES_FAILURE_ADD:
            return {
                ...state,
                allergiesAddLoading: false,
                allergiesAddResponse: {},
                allergiesAddeError: action.payload,
            }
        case allergiesType.ALLERGIES_REQUEST_UPDATE:
            return {
                ...state,
                allergiesUpdateLoading: true,
                allergiesUpdateResponse: {},
                allergiesUpdateError: null,
            }

        case allergiesType.ALLERGIES_SUCCESS_UPDATE:
            return {
                ...state,
                allergiesUpdateLoading: false,
                allergiesUpdateResponse: action.payload,
                allergiesUpdateError: null,
            }
        case allergiesType.ALLERGIES_FAILURE_UPDATE:
            return {
                ...state,
                allergiesAddLoading: false,
                allergiesAddResponse: {},
                allergiesAddeError: action.payload,
            }

        case allergiesType.ALLERGIES_REQUEST_DELETE:
            return {
                ...state,
                allergiesDeleteLoading: true,
                allergiesDeleteResponse: {},
                allergiesDeleteError: null,
            }

        case allergiesType.ALLERGIES_SUCCESS_DELETE:
            return {
                ...state,
                allergiesDeleteLoading: false,
                allergiesDeleteResponse: action.payload,
                allergiesDeleteError: null,
            }
        case allergiesType.ALLERGIES_FAILURE_DELETE:
            return {
                ...state,
                allergiesDeleteLoading: false,
                allergiesDeleteResponse: {},
                allergiesDeleteError: action.payload,
            }
        case allergiesType.ALLERGIES_REQUEST_GETBYID:
            return {
                ...state,
                allergiesGetIdLoading: true,
                allergiesGetIdResponse: {},
                allergiesGetIdError: null,
            }

        case allergiesType.ALLERGIES_SUCCESS_GETBYID:
            return {
                ...state,
                allergiesGetIdLoading: false,
                allergiesGetIdResponse: action.payload,
                allergiesGetIdError: null,
            }
        case allergiesType.ALLERGIES_FAILURE_GETBYID:
            return {
                ...state,
                allergiesGetIdLoading: false,
                allergiesGetIdResponse: {},
                allergiesGetIdError: action.payload,
            }

        default:
            return state;
    }


}

export default AllergiesReducer;